import React from 'react';

// Мы берем ее не из vkui так как баг в версии
export function CheckOutlineIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="currentColor">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.2243 0.175736C12.4586 0.410051 12.4586 0.78995 12.2243 1.02427L4.62426 8.62426C4.38995 8.85858 4.01005 8.85858 3.77574 8.62426L0.175736 5.02426C-0.0585786 4.78995 -0.0585786 4.41005 0.175736 4.17574C0.41005 3.94142 0.789949 3.94142 1.02426 4.17574L4.2 7.35147L11.3757 0.175736C11.61 -0.0585786 11.9899 -0.0585786 12.2243 0.175736Z"
                fill="white"
            />
        </svg>
    );
}
